// src/Recoil/TokenAtom.js
import { atom, selector } from 'recoil';

// sessionStorage에서 저장된 토큰을 가져옵니다.
const storedToken = sessionStorage.getItem('accessToken');

export const TokenAtom = atom({
    key: 'Token',
    default: storedToken || null,
});

export const isLoginSelector = selector({
    key: 'isLoginSelector',
    get: ({ get }) => {
        const token = get(TokenAtom);
        return !!token; // 토큰이 존재하면 true, 아니면 false 반환
    },
});